import styled from 'styled-components';

export const FareTrendWrapper = styled.div`
  background: #ffffff;
  border-radius: 0.5rem;
  padding: 0 1rem;
  height: 110px;
  max-width: 895px;

  & + .gi-srp-banners:not(:empty) {
    margin-top: 20px;
  }
`;

export const FareTrendInnerWrapper = styled.div`
  width: 100%;
  margin: 0.5rem 0;
  background: #ffffff;
  overflow: hidden;
  position: relative;
  float: left;
  font-size: 10px;
`;

export const TrendWrapper = styled.div`
  padding: 0 2.5rem;
  cursor: pointer;
`;

const FareTrendArrowWrapper = styled.span`
  height: 100%;
  width: 2.5rem;
  display: flex;
  align-items: center;
  position: absolute;
  cursor: pointer;
`;

export const FareTrendArrowWrapperLt = styled(FareTrendArrowWrapper)`
  justify-content: flex-start;
  left: 0;
`;

export const FareTrendArrowWrapperRt = styled(FareTrendArrowWrapper)`
  justify-content: flex-end;
  right: 0;
`;
